import React from 'react';
import s from './s.module.less';
import CasesTable from './components/CasesTable';
import { PermissionModuleKeys } from 'constants/access';
import AccessDenied from 'components/AccessDenied';
import AccessStore from 'store/Access/permission';

const TextVisitCasesPage = () => {
    const [getAccessStore] = AccessStore.useStore();
    const access = getAccessStore('data');

    return (
        <div className={s.wrap}>
            <div className={s.content}>
                {access?.[PermissionModuleKeys.KLARITY_ASSESSMENT] ? (
                    <div>
                        <h3 className={s.subtitle}>Cases</h3>
                        <CasesTable />
                    </div>
                ) : (
                    <AccessDenied />
                )}
            </div>
        </div>
    );
};

export default TextVisitCasesPage;
